import {
	ArrayNotEmpty,
	IsInt,
	IsNotEmpty,
	IsOptional,
	IsPositive,
	IsString,
	IsUUID,
	Min,
	ValidateNested,
} from 'class-validator';
import { FileDto } from './file.dto';
import { UserDto } from './user.dto';
import { IsAfter } from '../../decorators';
import { Type } from 'class-transformer';
import { CreateChallengeWeekDto } from './challenges-week.dto';

export class ChallengeDto {
	public id: string;
	public hostId: string;
	public name: string;
	public startDate: Date;
	public emailSendDate?: Date;
	public description: ChallengeDescriptionDto;
	public amount: number;
	public alias: string;
	public backgroundImageId: string;
	public backgroundVideoId?: string;

	/** @deprecated */
	public backgroundId?: string;
	/** @deprecated */
	public badgeFileId?: string;

	public stickerId: string;
	public primaryColor?: string;
	public challengeChatCid?: string;
	public onboardingGifFileId?: string;

	public createdAt: Date;
	public updatedAt: Date;
	public deletedAt?: Date;

	public host?: UserDto;
	public backgroundImage?: FileDto;
	public backgroundVideo?: FileDto;
	public sticker?: FileDto;
	
	/** @deprecated */
	public background?: FileDto;
	/** @deprecated */
	public badgeFile?: FileDto;
}

export class ChallengeGoalDto {
	@IsNotEmpty()
	@IsString()
	markdown: string;
}

export class ChallengeDescriptionDto {
	@IsNotEmpty()
	@IsString()
	primaryGoal: string;

	@IsNotEmpty()
	@IsInt()
	@IsPositive()
	weeks: number;

	@ArrayNotEmpty()
	@ValidateNested({ each: true })
	@Type(() => ChallengeGoalDto)
	goals: ChallengeGoalDto[];
}

export class CreateChallengeDto {
	@IsNotEmpty()
	@IsString()
	public name: string;

	@IsNotEmpty()
	@IsAfter('now')
	public startDate: Date;

	@IsOptional()
	@IsNotEmpty()
	@IsAfter('now')
	public emailSendDate?: Date;

	@IsNotEmpty()
	@ValidateNested()
	@Type(() => ChallengeDescriptionDto)
	public description: ChallengeDescriptionDto;

	@IsNotEmpty()
	@IsInt()
	@Min(0)
	public amount: number;

	@IsNotEmpty()
	@IsUUID()
	public backgroundImageId: string;

	@IsOptional()
	@IsUUID()
	public backgroundVideoId?: string;

	@ArrayNotEmpty()
	@ValidateNested({ each: true })
	@Type(() => CreateChallengeWeekDto)
	public weeks: CreateChallengeWeekDto[];

	@IsNotEmpty()
	@IsUUID()
	public stickerId: string;

	@IsOptional()
	@IsString()
	public primaryColor?: string;
}

export class UpdateChallengeDto extends CreateChallengeDto {
	@IsNotEmpty()
	@IsUUID()
	public id: string;
}
